import { render, staticRenderFns } from "./carFlowtoPeopleFlow.vue?vue&type=template&id=086f470c"
import script from "./carFlowtoPeopleFlow.vue?vue&type=script&lang=js"
export * from "./carFlowtoPeopleFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports